(() => {
  const roots = new WeakSet();
  const activeRoots = new Set();
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scrollTicking = false;

  const revealImmediately = (items) => {
    items.forEach((item) => item.classList.add('is-visible'));
  };

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const updateRootMotion = () => {
    activeRoots.forEach((root) => {
      if (!root.isConnected) {
        activeRoots.delete(root);
        return;
      }

      const hero = root.querySelector('.kz-hero');
      if (!hero) return;

      const rect = hero.getBoundingClientRect();
      const progress = clamp((0 - rect.top) / Math.max(rect.height, 1), 0, 1);
      root.style.setProperty('--kz-scroll-progress', progress.toFixed(3));
    });
  };

  const requestMotionUpdate = () => {
    if (scrollTicking || reduceMotion.matches) return;

    scrollTicking = true;
    window.requestAnimationFrame(() => {
      updateRootMotion();
      scrollTicking = false;
    });
  };

  const initCardGlow = (root) => {
    if (reduceMotion.matches) return;

    root.querySelectorAll('[data-kz-glow-card]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;

        card.style.setProperty('--kz-card-x', `${x.toFixed(2)}%`);
        card.style.setProperty('--kz-card-y', `${y.toFixed(2)}%`);
      });

      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--kz-card-x', '50%');
        card.style.setProperty('--kz-card-y', '50%');
      });
    });
  };

  const initAmbientPointer = (root) => {
    if (reduceMotion.matches) return;

    root.addEventListener('pointermove', (event) => {
      const rect = root.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      root.style.setProperty('--kz-pointer-x', `${clamp(x, 0, 100).toFixed(2)}%`);
      root.style.setProperty('--kz-pointer-y', `${clamp(y, 0, 100).toFixed(2)}%`);
    });
  };

  const initPremiumHome = (root) => {
    if (!root || roots.has(root)) return;

    roots.add(root);
    root.setAttribute('data-kz-animated', 'true');

    const revealItems = Array.from(root.querySelectorAll('.kz-reveal'));

    if (reduceMotion.matches) {
      revealImmediately(revealItems);
      return;
    }

    initCardGlow(root);
    initAmbientPointer(root);
    activeRoots.add(root);
    updateRootMotion();

    if (!('IntersectionObserver' in window)) {
      revealImmediately(revealItems);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.16,
      }
    );

    revealItems.forEach((item, index) => {
      item.style.setProperty('--kz-reveal-delay', `${Math.min(index * 55, 220)}ms`);
      observer.observe(item);
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-kz-premium-home]').forEach(initPremiumHome);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-kz-premium-home]');
    initPremiumHome(root);
  });

  window.addEventListener('scroll', requestMotionUpdate, { passive: true });
  window.addEventListener('resize', requestMotionUpdate);
})();
